module.exports = __webpack_public_path__ + "img/trouble@3x.4dba01be.png";